import { useMemo } from "react";

import { selectProjectsAcrossEnvironments } from "../store";
import { useEnvironmentStoreSnapshot } from "./useEnvironmentStoreSnapshot";

/**
 * Every project the app can see, from every environment.
 *
 * The snapshot is memoised before the selector runs, not after: the selector
 * takes an object, and rebuilding that object each render would give it a new
 * identity every time and defeat its own memo — which is what made two
 * copies of this drift into subtly different dependency arrays.
 */
export function useProjectsAcrossEnvironments() {
  const storeSnapshot = useEnvironmentStoreSnapshot();
  return useMemo(() => selectProjectsAcrossEnvironments(storeSnapshot), [storeSnapshot]);
}
